import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AppLayout from "../components/layout/AppLayout";

// Public pages
import Home from "../pages/home/page";

// Dashboard
import Dashboard from "../pages/dashboard/page";

// Reception
import ReceptionShifts from "../pages/reception/shifts/page";
import ReceptionCheckin from "../pages/reception/checkin/page";
import ReceptionCheckout from "../pages/reception/checkout/page";
import ReceptionBilling from "../pages/reception/billing/page";
import ReceptionCash from "../pages/reception/cash/page";
import ReceptionLogs from "../pages/reception/logs/page";
import ReceptionReports from "../pages/reception/reports/page";

// Bookings
import BookingRooms from "../pages/bookings/rooms/page";
import BookingNew from "../pages/bookings/new/page";
import BookingManage from "../pages/bookings/manage/page";
import BookingGuests from "../pages/bookings/guests/page";
import BookingBilling from "../pages/bookings/billing/page";
import BookingReports from "../pages/bookings/reports/page";

// Inventory
import InventoryStock from "../pages/inventory/stock/page";
import InventoryPurchases from "../pages/inventory/purchases/page";
import InventoryVendors from "../pages/inventory/vendors/page";
import InventoryReports from "../pages/inventory/reports/page";

// Canteen
import CanteenMenu from "../pages/canteen/menu/page";
import CanteenBilling from "../pages/canteen/billing/page";
import CanteenHistory from "../pages/canteen/history/page";
import CanteenReports from "../pages/canteen/reports/page";

// Users
import UserManage from "../pages/users/manage/page";
import UserPermissions from "../pages/users/permissions/page";

// Expense Tracking
import ExpensesDaily from "../pages/expenses/daily/page";

// Housekeeping
import Housekeeping from "../pages/housekeeping/page";

// Night Audit
import NightAudit from "../pages/reception/night-audit/page";

// Rate Calendar
import RateCalendar from "../pages/bookings/rate-calendar/page";

function LayoutWrapper({ children }: { children: React.ReactNode }) {
  return <AppLayout>{children}</AppLayout>;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dashboard",
    element: <LayoutWrapper><Dashboard /></LayoutWrapper>,
  },
  {
    path: "/reception/shifts",
    element: <LayoutWrapper><ReceptionShifts /></LayoutWrapper>,
  },
  {
    path: "/reception/checkin",
    element: <LayoutWrapper><ReceptionCheckin /></LayoutWrapper>,
  },
  {
    path: "/reception/checkout",
    element: <LayoutWrapper><ReceptionCheckout /></LayoutWrapper>,
  },
  {
    path: "/reception/billing",
    element: <LayoutWrapper><ReceptionBilling /></LayoutWrapper>,
  },
  {
    path: "/reception/cash",
    element: <LayoutWrapper><ReceptionCash /></LayoutWrapper>,
  },
  {
    path: "/reception/logs",
    element: <LayoutWrapper><ReceptionLogs /></LayoutWrapper>,
  },
  {
    path: "/reception/reports",
    element: <LayoutWrapper><ReceptionReports /></LayoutWrapper>,
  },
  {
    path: "/bookings/rooms",
    element: <LayoutWrapper><BookingRooms /></LayoutWrapper>,
  },
  {
    path: "/bookings/new",
    element: <LayoutWrapper><BookingNew /></LayoutWrapper>,
  },
  {
    path: "/bookings/manage",
    element: <LayoutWrapper><BookingManage /></LayoutWrapper>,
  },
  {
    path: "/bookings/guests",
    element: <LayoutWrapper><BookingGuests /></LayoutWrapper>,
  },
  {
    path: "/bookings/billing",
    element: <LayoutWrapper><BookingBilling /></LayoutWrapper>,
  },
  {
    path: "/bookings/reports",
    element: <LayoutWrapper><BookingReports /></LayoutWrapper>,
  },
  {
    path: "/inventory/stock",
    element: <LayoutWrapper><InventoryStock /></LayoutWrapper>,
  },
  {
    path: "/inventory/purchases",
    element: <LayoutWrapper><InventoryPurchases /></LayoutWrapper>,
  },
  {
    path: "/inventory/vendors",
    element: <LayoutWrapper><InventoryVendors /></LayoutWrapper>,
  },
  {
    path: "/inventory/reports",
    element: <LayoutWrapper><InventoryReports /></LayoutWrapper>,
  },
  {
    path: "/canteen/menu",
    element: <LayoutWrapper><CanteenMenu /></LayoutWrapper>,
  },
  {
    path: "/canteen/billing",
    element: <LayoutWrapper><CanteenBilling /></LayoutWrapper>,
  },
  {
    path: "/canteen/history",
    element: <LayoutWrapper><CanteenHistory /></LayoutWrapper>,
  },
  {
    path: "/canteen/reports",
    element: <LayoutWrapper><CanteenReports /></LayoutWrapper>,
  },
  {
    path: "/users/manage",
    element: <LayoutWrapper><UserManage /></LayoutWrapper>,
  },
  {
    path: "/users/permissions",
    element: <LayoutWrapper><UserPermissions /></LayoutWrapper>,
  },
  {
    path: "/expenses/daily",
    element: <LayoutWrapper><ExpensesDaily /></LayoutWrapper>,
  },
  {
    path: "/housekeeping",
    element: <LayoutWrapper><Housekeeping /></LayoutWrapper>,
  },
  {
    path: "/reception/night-audit",
    element: <LayoutWrapper><NightAudit /></LayoutWrapper>,
  },
  {
    path: "/bookings/rate-calendar",
    element: <LayoutWrapper><RateCalendar /></LayoutWrapper>,
  },
  {
    path: "*",
    element: <LayoutWrapper><NotFound /></LayoutWrapper>,
  },
];

export default routes;